export default __webpack_public_path__ + "images/14552a2c9ab3751ad18378ac08af4281-robotics.webp";